import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Card, CardActions } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { green, red } from "@mui/material/colors";
import { useLocation, useNavigate } from "react-router-dom";

const StatusMessage = ({ severity, message }) => {
  const icon = severity === "success" ? <CheckCircleIcon /> : <ErrorOutlineIcon />;
  const bgColor = severity === "success" ? green[600] : red[700];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: bgColor,
        color: "common.white",
        p: 4,
        borderRadius: "8px 8px 0 0",
      }}
    >
      {React.cloneElement(icon, { sx: { fontSize: 40, mb: 1 } })}
      <Typography variant="h6" fontWeight="bold" align="center">
        {message}
      </Typography>
    </Box>
  );
};

export const PasswordResetResult = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { severity, message } = state || {};

  // Si alguien entra directo a esta página sin state, volvemos al form
  useEffect(() => {
    if (!state) navigate("/forgot-password", { replace: true });
  }, [state, navigate]);

  return (
    <Card sx={{ maxWidth: 500, mx: "auto", mt: 8, boxShadow: 3 }}>
      <StatusMessage severity={severity} message={message} />
      <CardActions sx={{ justifyContent: "center", p: 3 }}>
        <Button variant="contained" onClick={() => navigate("/")}>
          Volver al inicio
        </Button>
      </CardActions>
    </Card>
  );
};

